export default "__VITE_ASSET__AwyYJyMa__"